export function getPageFromUrl(url: string | null) {
  if (!url || url === null) return undefined;

  return new URLSearchParams(url).get('page') || undefined;
}
